import type { LevelData } from '@/game/level';
import type { Selection } from './editor-store';

/** Return the top-most selectable at a world (x,y), or null. */
export function hitTest(lvl: LevelData, wx: number, wy: number): Selection | null {
  let segOffset = 0;
  for (const seg of lvl.segments) {
    for (let i = 0; i < seg.obstacles.length; i++) {
      const o = seg.obstacles[i];
      const ox = segOffset + o.position.along;
      const oy = 80 + o.position.up; // matches preview's baseY math
      if (o.type === 'spike' || o.type === 'wall' || o.type === 'moving') {
        if (wx >= ox && wx <= ox + o.size.width &&
            wy >= oy && wy <= oy + o.size.height) {
          return { kind: 'obstacle', segmentId: seg.id, index: i };
        }
      }
    }
    segOffset += seg.length;
  }
  for (const t of lvl.triggers) {
    if (Math.abs(t.position - wx) < 6) {
      return { kind: 'trigger', id: t.id };
    }
  }
  for (let i = 0; i < lvl.collectibles.length; i++) {
    const c = lvl.collectibles[i];
    if (Math.abs(c.position.along - wx) < 10 && Math.abs((80 + c.position.up) - wy) < 10) {
      return { kind: 'collectible', index: i };
    }
  }
  return null;
}
